// @ts-ignore untyped upstream dependency module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { jsxs as _jsxs } from "react/jsx-runtime";
const OpenPaidMeetingPrice = ({
  currency
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [getNativeCurrencySymbol(currency), " --"]
  });
};
export default OpenPaidMeetingPrice;